import React from 'react';
import clsx from 'clsx';
import { MessageDescriptor, useIntl } from 'react-intl';
import { CreditPackId, OfferedCreditPack } from 'fym-shared/src/music24/creditPacks';
import { TypedMemo } from '../../../common/types';
import { creditMessages } from './creditMessages';
import { useDisplayCurrency } from '../../config/useDisplayCurrency';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the video credits; each part uses its own slice of it */
import styles from './Credits.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The line under each pack on sale. A retired pack is never offered, so it has no line. */
const PACK_LINES: Partial<Record<CreditPackId, MessageDescriptor>> = {
  music24_creditpack_10: creditMessages.pack10,
  music24_creditpack_30: creditMessages.pack30,
  music24_creditpack_100: creditMessages.pack100,
};

interface CreditPackOptionProps {
  pack: OfferedCreditPack;
  isSelected: boolean;
  onSelect: (pack: OfferedCreditPack) => void;
}

/** One pack of the packs modal (design g8): the count, the name, the line and the price. */
const CreditPackOptionComponent: React.FC<CreditPackOptionProps> = ({ pack, isSelected, onSelect }) => {
  const intl = useIntl();
  // A pack costs the same number in USD and EUR; the symbol follows the visitor, and the Checkout
  // charges that currency (QA finding D12).
  const currency = useDisplayCurrency();
  const price = intl.formatNumber(pack.priceUsd, { style: 'currency', currency, maximumFractionDigits: 0 });

  return (
    <button
      type="button"
      role="radio"
      aria-checked={isSelected}
      className={clsx(styles.pack, isSelected && styles.packOn)}
      onClick={() => onSelect(pack)}
    >
      <span className={styles.packCount}>{pack.credits}</span>
      <span className={styles.packText}>
        <span className={styles.packName}>{intl.formatMessage(creditMessages.packName, { count: pack.credits })}</span>
        <span className={styles.muted}>
          {intl.formatMessage(PACK_LINES[pack.id] ?? creditMessages.packName, { count: pack.credits })}
        </span>
      </span>
      <span className={styles.packPrice}>{price}</span>
    </button>
  );
};

export const CreditPackOption = TypedMemo(CreditPackOptionComponent);
